module.exports = __webpack_public_path__ + "3.2225b5ce8aa1f216a7a5.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/GKool/source/repos/e2epublicwebsite/src/assets/images/gallery/3.png
// module id = ../../../../../src/assets/images/gallery/3.png
// module chunks = 0